/*
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-17 15:00:14
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-04-17 16:04:24
 * @FilePath: /goldenSales/src/utils/clipboard.js
 * @Description: 
 */
import Clipboard from 'clipboard';

function clipboardSuccess() {
// console.log('复制成功')
}

function clipboardError() {
// console.log('复制失败')
}

export function handleClipboard(text, event, onSuccess, onError) {
  event = event || {};
  const clipboard = new Clipboard(event.target, {
    text: () => text,
  });
  clipboard.on('success', () => {
    onSuccess ? onSuccess() : clipboardSuccess();
    // 释放内存
    clipboard.off('error');
    clipboard.off('success');
    clipboard.destroy();
  });
  clipboard.on('error', () => {
    onError ? onError() : clipboardError();
    // 释放内存
    clipboard.off('error');
    clipboard.off('success');
    clipboard.destroy();
  });
  clipboard.onClick(event);
}

